import { tokens } from './cunningham-tokens';

const themeTokens = tokens.themes.default.theme;
const colorsTokens = tokens.themes.default.theme.colors;
const sizesTokens = tokens.themes.default.theme.spacings.sizes;
const componentTokens = tokens.themes.default.components;
export { tokens, themeTokens, componentTokens, colorsTokens, sizesTokens };
